import api from './api_config';

export async function checkLogin() {
  const result = await api.get('/api/checkLogin');
  return result.data;
}

export async function getCodeList(codeList = []) {
  let form = new FormData();
  form.append('cmmCdSortCdList', JSON.stringify(codeList.map((e) => ({ comboObjId: e, sortCd: e }))));

  const result = await api.post('/cmm/codeList.do', form);
  //const queryString = '?' + new URLSearchParams(param).toString();
  //const result = await api.get('/cmm/codeList.do' + queryString);
  return result.data;
}
